<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>
      <el-button type="primary" @click="save()" :disabled="data.Status==2||!canWrite">保 存</el-button>
      <el-button type="primary" @click.native="orderReview" :disabled="!isSave || !canReview">{{ data.Status == 2 ? "弃审" : "审核" }}</el-button>
      <el-button type="primary" @click.native="orderDel" :disabled="data.Status==2|| !isSave || !canWrite">删除</el-button>
      <!-- <el-button @click="close">关 闭</el-button> -->
    </div>
    <el-form
      ref="dialog"
      :data="data"
      label-width="110px"
      :model="data"
      :rules="rules"
      :inline="true"
    >
      <div class="row-head">基本信息</div>
      <el-row class="border">
        <el-form-item label="单据编号:" prop="DocNo">
          <span
            v-if="Mode == 0 || isDetails"
            class="detail-span"
            style="width: 193px"
            >{{ data.DocNo }}</span
          >
          <el-input v-else v-model="data.DocNo" style="width: 193px"></el-input>
        </el-form-item>
        <el-form-item label="单据日期:" prop="DocDate">
          <span class="not-edit" v-if="isDetails">{{
            $commonJs.toDateString(data.DocDate)
          }}</span>
          <el-date-picker
            v-else
            v-model="data.DocDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 193px"
            @change="(v) => previewNo(v)"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="业务类型:" prop="BusinessTypeId">
          <span class="not-edit" v-if="isDetails">{{ data.BusinessType }}</span>
          <business-select
            v-else
            v-model="data.BusinessTypeId"
            :params="{ Kind: '应收', SourceType: '收入单' }"
          />
        </el-form-item>
        <el-form-item label="往来单位:" prop="TradeUnitId">
          <span class="not-edit" v-if="isDetails">{{
            data.TradeUnitName
          }}</span>
          <el-select 
              v-else 
              v-model="data.TradeUnitId"
              filterable style="width: 180px">
              <el-option
                v-for="item in tradeUnitList"
                :key="item.TradeUnitId"
                :value="item.TradeUnitId"
                :label="item.FullName"
                @click.native="setTradeunit(item)"
              ></el-option>
            </el-select>
          <!-- <select-input
            v-else
            placeholder="请选择单位"
            :label="data.TradeUnitName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
          /> -->
        </el-form-item>
        <el-form-item label="收款到期日:" prop="LastDate">
          <span class="not-edit" v-if="isDetails">{{
            $commonJs.toDateString(data.LastDate)
          }}</span>
          <el-date-picker
            v-else
            v-model="data.LastDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 193px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="经办人:" prop="ClerkId">
          <span class="not-edit" v-if="isDetails">{{ data.ClerkName }}</span>
          <select-input
            v-else
            placeholder="请选择经办人"
            :label="data.ClerkName"
            v-model="data.ClerkId"
            @click="openEmp"
          />
        </el-form-item>
        <el-row>
          <el-form-item label="备注:" prop="Remark">
            <span class="not-edit" v-if="isDetails">{{ data.Remark }}</span>
            <el-input
              v-else
              type="textarea"
              v-model="data.Remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="60"
              placeholder="请填写备注信息"
              style="width: 600px"
            />
          </el-form-item>
        </el-row>
      </el-row>

      <div class="row-tb-head" style="margin-top: 10px">
        <span>单据明细</span>
        <div style="float: right">
          <el-button type="primary" v-if="!isDetails" @click="add"
            >添加</el-button
          >
          <!-- <el-button type="danger" @click="del">删除</el-button> -->
        </div>
      </div>
      <!-- :data="data.RpOtherReceivDts" -->
      <el-table
        ref="table"
        class="table-line tb-c-head"
        @selection-change="handleSelectionChange"
        :data="data.RpOtherReceivDts"
        show-summary
        border
      >
        <el-table-column label="摘要" align="center" min-width="200">
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.Abstract }}</span>
            <el-select
              v-else
              v-model="row.Abstract"
              allow-create
              filterable
              @change="onChange(row)"
            >
              <el-option
                v-for="(i, key) in Abstract"
                :key="key"
                :label="i"
                :value="i"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="项目" align="center" min-width="140">
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.ItemName }}</span>
            <item-select
              v-else
              v-model="row.ItemName"
              :source="DItems"
              @select="onSelect($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="Amount" label="金额" align="center" width="120" v-if="canPrice">
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.Amount }}</span>
            <el-input
              v-else
              type="number"
              @input="onInput(row)"
              v-model="row.Amount"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="60px"
          v-if="!isDetails"
        >
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="del(row, $index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import areaDialog from "@/components/basedata/basedoc/district/listDialog";
import businessSelect from "@/components/basedata/basedoc/business/select";
import empDialog from "@/components/personnel/result/record/listDialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import itemSelect from "@/components/basedata/finance/incomeitems/select";
export default {
  name: "editOthereceive",
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    areaDialog,
    businessSelect,
    empDialog,
    tradeunitDialog,
    itemSelect,
  },
  computed: {
    isSave() {
      return Boolean(this.data.OtherReceivId > 0);
    },
    isDetails() {
      return Boolean(this.data.Status === 2);
    },
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/othereceive");
    },
    canWrite() {
      return this.$permission.canWrite("/finance/dealings/othereceive");
    },
    canReview() {
      return this.$permission.canReview("/finance/dealings/othereceive");
    },
  },
  data() {
    return {
      data: {
        OtherReceivId: 0,
        DocNo: "",
        // DocDate: this.$commonJs.getToday(), //单据日期
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        BusinessTypeId: null, //业务类型
        LastDate: null, //付款到期日
        ClerkId: null, //经办人
        ClerkName: "",
        // Amount: null, //金额
        // TaxAmount: null, //税额
        // IncTaxAmount: null, //含税金额
        Remark: "",
        NeedTradeUnit: true,
        RpOtherReceivDts: [],
        Status: 0,
      },
      Mode: 0,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/rp/otherReceiv").default,
      abstract_api: require("@/api/ba/abstract").default,
      item_api: require("@/api/ba/item").default,
      code_api: require("@/api/sy/serialCode").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      // trendData: iForm.Data,
      showList: [],
      DelRpOtherReceivDts: [],
      Abstract: [],
      DItems: [],
      multipleSelection: [],
      tradeUnitList: [],
      rules: {
        DocNo: [{ required: true, message: "单据编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        BusinessTypeId: [{ required: true, message: "业务类型不能为空" }],
        TradeUnitId: [{ required: true, message: "单据编号不能为空" }],
        LastDate: [{ required: true, message: "收款到期日不能为空" }],
        ClerkId: [{ required: true, message: "经办人不能为空" }],
      },
    };
  },
  beforeMount() {
    this.onOpened();
    this.getCurd();
  },
  methods: {
    previewNo(dateTime = "") {
      this.code_api.previewNo("其它应收单", dateTime).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取其它应收单编号失败");
        }
      });
    },
    onSelect(e, row) {
      row.T = row.T == 0 ? 0 : 1;
      row.ItemId = e.ItemId;
      row.ItemName = e.ItemName;
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      // row.Amount = this.$commonJs.obj.toNumber(row.Amount);
    },
    getCurd() {
      const row = this.$route.params.data ?? {};
      switch (this.$route.params.mode) {
        case "create":
          this.onCreateOpened();
          break;
        case "edit":
          this.onEditOpened(row);
          break;
        case "editById":
          this.onEditOpened(row);
          break;
        case "details":
          this.onDetailsOpened(row);
          break;
        default:
          this.onCreateOpened();
          break;
      }
    },
    // 打开时获取显示显示列表
    onOpened() {
      this.abstract_api.list({ SourceType: "其它应收单" }).then((res) => {
        if (res.Code == 0) this.Abstract = res.Data.map((x) => x.Abstract);
      });
      this.item_api.list({ Status: 1, ItemType: 0 }).then((res) => {
        if (res.Code == 0) this.DItems = res.Data;
      });
      console.log(this.$commonJs.getDay);
      this.tradeUnitApi.list({ TradeUnitTypes: [0,2],Status:1 }).then((res) => {
        if (res.Code == 0) this.tradeUnitList = res.Data;
      });
    },
    onCreateOpened() {
      this.previewNo();
      var user = this.$store.state.user;
      this.data.DocDate = this.$commonJs.getToday();
      // console.log("user", JSON.parse(JSON.stringify(user)));
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
    },
    onEditOpened(data) {
      this.api.info(data.OtherReceivId).then((res) => {
        if (res.Code === 0) {
          this.data = res.Data;
        }
      });
    },
    onDetailsOpened(data) {
      // console.log("object");
      this.api.info(data.OtherReceivId).then((res) => {
        if (res.Code === 0) {
          this.data = res.Data;
        }
      });
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    onChange(row) {
      row.T = row.T == 0 ? 0 : 1;
    },
    // onChange(data) {
    //   if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
    //   else this.data.NeedTradeUnit = true;
    //   this.$refs.dialog.clearValidate();
    // },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    save(type = 0) {
      this.$refs.dialog.validate((valid) => {
        if(!valid) return;
        if (this.data.RpOtherReceivDts.length == 0) {
          this.$message.warning("单据明细不能为空");
          return false;
        }

        var abstract = this.data.RpOtherReceivDts.every((x) => !!x.Abstract);
        if (!abstract) {
          this.$message.warning("单据明细 - 摘要不能为空");
          return false;
        }
        var itemId = this.data.RpOtherReceivDts.every((x) => !!x.ItemId);
        // if (!itemId) {
        //   this.$message.warning("单据明细 - 项目不能为空");
        //   return false;
        // }
        var amount = this.data.RpOtherReceivDts.every((x) => !!x.Amount);
        if (!amount) {
          this.$message.warning("单据明细 - 金额不能为空");
          return false;
        }
    
        var data = this.$commonJs.obj.removeNullKey(this.data);
        data.RpOtherReceivDts = this.data.RpOtherReceivDts.filter(
          (x) => x.T != null
        );
        this.DelRpOtherReceivDts.forEach((x) => data.RpOtherReceivDts.push(x));
        data.RpOtherReceivDts.forEach((x)=>{
          if(x.ItemId==null){
            x.ItemId=0
          }
        })
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            if(type !== 1){
              this.$message.success(res.Msg);
            }
            // const id = this.data.DocId == 0 ? res.Data : this.data.DocId;
            let id =this.data.OtherReceivId==0? res.Data : this.data.OtherReceivId;   
            this.api.info(id).then((result) => {
              this.data = result.Data;
              if(type === 1){
                this.Review();
              }
            });
            this.onClosed(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
        return false;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    add() {
      this.data.RpOtherReceivDts.push({
        OtherReceivDtsId: 0,
        OtherReceivId: this.data.OtherReceivId,
        // AbstractId: null,
        Abstract: "", //摘要
        ItemId: null,
        ItemName: "",
        Amount: null,
        // IncTaxAmount: null,
        // TaxAmount: null,
        // WriteoffAmount: null,
        Remark: "",
        T: 0,
      });
    },
    RestartOrder() {
      // this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.onOpened();
      this.onCreateOpened();
      this.add();

      setTimeout(() => {
        this.$refs.dialog.clearValidate();
      }, 30);
    },
    Review(){
      this.api.examine(this.data.OtherReceivId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.onEditOpened(this.data);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.OtherReceivId == 0) {
        this.$message.warning("单据未保存");
        return;
      }
      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "cancel" : "examine";
          if(data === 'examine'){
            this.save(1);
          }else if(data === 'cancel'){
            this.api[data](this.data.OtherReceivId).then((res) => {
              if (res.Code === 0 && data == "examine") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "cancel") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.onEditOpened(this.data);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.OtherReceivId == 0) {
        this.$message.warning("单据未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.OtherReceivId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    del(row, index) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.DelRpOtherReceivDts.splice(index, 1);
          if (row.T != 0) this.DelRpOtherReceivDts.push({ ...row, T: 2 });
          this.data.RpOtherReceivDts.splice(index, 1);
        })
        .catch(() => {});
    },
    onClosed() {
      this.showList = [];
      this.multipleSelection = [];
      this.DelRpOtherReceivDts = [];
      this.data.DetailDtos = [];
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;
  .el-button {
    margin-left: 4px;
  }
}
.detail-span {
  padding-left: 0;
  display: inline-block;
}
.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}
</style>
